import { JobPost } from "../types";
import AdminPanelJobPostCard from "./AdminPanelJobPostCard";

import { Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import api from "../../../api";
import { getBackendUrl } from "../../../util/envFn";

const AdminPanelJobList = () => {
    const [jobPosts, setJobPosts] = useState<JobPost[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    const fetchJobs = () => {
        api.get(getBackendUrl("jobs"))
            .then(res => setJobPosts(res.data.sort((a: JobPost, b: JobPost) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())))
            .catch(err => enqueueSnackbar("Failed to fetch jobs", { variant: "error" }));
    }

    useEffect(() => {
        fetchJobs();
    }, []);

    return (
        <Stack gap={2}>
            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
                Job List
            </Typography>
            <Stack sx={{ mb: 4, gap: 2 }}>
                {jobPosts.map((job, index) =>
                    <AdminPanelJobPostCard
                        key={index}
                        job={job}
                        index={index}
                        fetchJobs={fetchJobs}
                    />)
                }
            </Stack>
        </Stack>
    )
}

export default AdminPanelJobList;   
